import { render, staticRenderFns } from "./StudyVisaView.vue?vue&type=template&id=3f06de92&scoped=true"
import script from "./StudyVisaView.vue?vue&type=script&lang=js"
export * from "./StudyVisaView.vue?vue&type=script&lang=js"
import style0 from "./StudyVisaView.vue?vue&type=style&index=0&id=3f06de92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f06de92",
  null
  
)

export default component.exports